var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import {} from "@/api";
import { updateObjectStore } from "@/api/objectStores";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import RelocateDialog from "./RelocateDialog.vue";
import SelectModal from "./SelectModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RelocateLink',
    props: {
        datasetStorageDetails: null,
        datasetId: null
    },
    emits: ["relocated"],
    setup(__props, { emit }) {
        const props = __props;
        const showModal = ref(false);
        const store = useObjectStoreStore();
        const { isLoaded, selectableObjectStores } = storeToRefs(store);
        const currentObjectStore = computed(() => {
            const isLoadedVal = isLoaded.value;
            const objectStores = selectableObjectStores.value;
            const currentObjectStoreId = props.datasetStorageDetails.object_store_id;
            if (!isLoadedVal) {
                return null;
            }
            if (!objectStores) {
                return null;
            }
            const filtered = objectStores.filter((objectStore) => objectStore.object_store_id == currentObjectStoreId);
            return filtered && filtered.length > 0 ? filtered[0] : null;
        });
        const validTargets = computed(() => {
            const isLoadedVal = isLoaded.value;
            const objectStores = selectableObjectStores.value;
            const currentObjectStoreId = props.datasetStorageDetails.object_store_id;
            if (!isLoadedVal) {
                return [];
            }
            if (!objectStores) {
                return [];
            }
            if (!currentObjectStore.value) {
                return [];
            }
            const currentDevice = currentObjectStore.value.device;
            if (!currentDevice) {
                return [];
            }
            const validTargets = objectStores.filter((objectStore) => objectStore.device == currentDevice && objectStore.object_store_id != currentObjectStoreId);
            return validTargets;
        });
        const relocatable = computed(() => {
            return validTargets.value.length > 0;
        });
        function closeModal() {
            showModal.value = false;
        }
        function relocate(objectStoreId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield updateObjectStore(props.datasetId, objectStoreId);
                    emit("relocated");
                }
                catch (err) {
                    console.log(err);
                }
                finally {
                    showModal.value = false;
                }
            });
        }
        return { __sfc: true, props, showModal, store, isLoaded, selectableObjectStores, currentObjectStore, validTargets, relocatable, emit, closeModal, relocate, BButton, RelocateDialog, SelectModal };
    }
});
